import React, { useState, useEffect, useMemo } from "react";
import {  Row } from "react-bootstrap";
import "../utils/style.css";
import TableContainer from "../../../common/table/TableContainer";
import { useQuery, useQueryClient } from "react-query";
import { getAllColloborators } from "../services/roleApi";
import StaticRoles from "../component/staticRole";
import Collaborateur from "../component/collaborator";
import NewCollaboratorModal from "../component/newCollaborateurModal";
import edit from "../../../assets/images/edit.png";
import archive from "../../../assets/images/archive.png";
import eye from "../../../assets/images/eye.png";
import lamp from "../../../assets/images/lamp.png";
import { Modal } from "antd";
import CollaboratorDetailModal from "../component/CollaboratorDetailModal";
import DeleteCollaboratorModal from "../component/deleteCollaboratorModal";

const Roles = () => {
 const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
const currentMerchantId = currentUser?.user?.id;
const role = currentUser?.roles;
const [activeTab, setActiveTab] = useState("Collaborateurs");
 const handleTabClick = (tab) => {
setActiveTab(tab);
  }; 
  const tabs = ["Administrateur", "Collaborateurs"];
     const [activeTab1, setActiveTab1] = useState("Administrateur");
      const handleTabChange = (tab1) => {
      setActiveTab1(tab1);
    };
const merchantId =currentMerchantId // récupéré depuis ton auth context ou redux
const { isLoading, isError, error, data: colloborateurs, refetch } = useQuery(
  ["colloborateurs", merchantId],
  () => getAllColloborators(merchantId),
  {
    enabled: !!merchantId, // ne fetch que si l’ID est défini
  }
);
const timeAgo = (date) => {
  if (!date) return "-";
  const diffMs = Date.now() - new Date(date).getTime();
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffH = Math.floor(diffMin / 60);
  const diffD = Math.floor(diffH / 24);

  if (diffSec < 60) return `il y a ${diffSec} sec`;
  if (diffMin < 60) return `il y a ${diffMin} min`;
  if (diffH < 24) return `il y a ${diffH} h`;
  return `il y a ${diffD} j`;
};
 const [showModal, setShowModal] = useState(false);
 const [showDetailModal, setShowDetailModal] = useState(false);
 const [editingCollab, setEditingCollab] = useState(null);
const [showDelete, setShowDelete] = useState(false);
const [selectedCollab, setSelectedCollab] = useState(null);
const handleEdit = (collab) => {
  setEditingCollab(collab);
  setShowModal(true);
};
const openModal = () => setShowModal(true);
const closeModal = () => setShowModal(false);
const [isModalOpen, setIsModalOpen] = useState(false);
const [modalPosition, setModalPosition] = useState({ top: 0, left: 0 });
const [selectedMerchant, setSelectedMerchant] = useState(null);

  const columns = useMemo(() => [
{
   Header: () => (
    <div className="name" style={{ textAlign: "center", width: "50%" }}>
     Nom complet
    </div>
  ),
  accessor: "fullName",
  filterable: false,
  Cell: ({ row }) => {
    const { fullName, profilePhoto } = row.original;
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px",width:'' }}>
           👤
        <span className="names">{fullName}</span>
      </div>
    );
  }
}, 
{
    Header: () => (
    <div style={{ textAlign: "left", width: "100%" }} className="name">
    Date d'ajout
    </div>
  ),
  accessor: "createdDate",
   Header: () => (
   <div className="name" style={{ textAlign: "center", width: "50%" }}>
    createdDate
    </div>
  ),
  Cell: ({ value }) =>
  value ? (
    <span className="names">
      {new Date(value).toLocaleString("fr-FR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })}
    </span>
  ) : (
    <span className="names">-</span>
  ),

      
  filterable: false,
},
{
  Header: () => (
    <div className="name" style={{ textAlign: "center", width: "50%" }}>
      Actif
    </div>
  ),
  id: "actif",
  accessor: (row) => row?.createdDate,
  Cell: ({ value }) => (
    <span className="names">{timeAgo(value)}</span>
  ),
  filterable: false,
},
{
  Header: () => (
    <div className="name" style={{ textAlign: "center", width: "50%" }}>
      Rôle
    </div>
  ),
  accessor: "role",
  Cell: ({ value }) => {
    const style = {
      backgroundColor: "#F6F6F6",
      color: "#000",
      padding: "1px 6px",
      borderRadius: "100px",
      fontWeight: 400,
      fontSize: "13px",
      fontStyle: "Medium"
    };

    return (
      <span className="names" style={style}>
        {value}
      </span>
    );
  },
  filterable: false,
},
  
 {
  Header: () => (
    <div className="name" style={{ textAlign: "right", width: "100%" }}>
      Action
    </div>
  ),
  accessor: "action",
  Cell: ({ row }) => {
    const collab = row.original;
    const handleClick = (e) => {
      const rect = e.currentTarget.getBoundingClientRect();
      setModalPosition({
        top: rect.bottom + window.scrollY + 5, 
        left: rect.left + window.scrollX - 150,
      });
      setSelectedMerchant(collab);
      setIsModalOpen(true);
    };
    return (
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <div
          onClick={handleClick}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: "24px",
            height: "24px",
           backgroundColor: "#F2F5FF",
            borderRadius: "50%",
            cursor: "pointer",
            border: "1px solid #F2F5FF",
          }}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="6" cy="12" r="2" fill="#3761FF" />
            <circle cx="12" cy="12" r="2" fill="#3761FF" />
            <circle cx="18" cy="12" r="2" fill="#3761FF" />
          </svg>
        </div>
      </div>
    );
  },
  filterable: false,
},

  ]);

  return (
    <Row className="">
     <div className="d-flex flex-column align-items-start gap-3 w-100">
    <div className='title-page mb-2'>
     Gestion des rôles
    </div>
     <div className="alertRole">
          <div className="textes">
           <img src={lamp} alt="Voir détails" style={{ width: 20, height: 20}} />&ensp;
           Créer, modifier et attribuer des rôles à vos collaborateurs sur votre plateforme. Vous pouvez définir les permissions spécifiques pour chaque rôle, assurant ainsi un accès sécurisé et adapté aux différentes fonctionnalités.
          </div>
        </div>
    </div>
       <div style={{ height: "16vh", justifyContent: "center", alignItems: "start", display: "flex",flexDirection: "column", }}>
          <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "20px",
            marginBottom: "5px",
            position: "relative",
          }}
        >
          {["Collaborateurs","Rôles"].map((tab) => (
            <div
              key={tab}
              onClick={() => handleTabClick(tab)}
              style={{
                margin: "0 20px",
                cursor: "pointer",
                color: activeTab === tab ? "#3761FF" : "#00000073",
                fontWeight: activeTab === tab ? 400 : 400,
                fontSize: activeTab === tab ? '16px' : '16px',
                fontFamily: activeTab === tab ? 'Poppins' : 'Poppins',
                fontStyle: activeTab === tab ? 'normal' : 'normal',
                position: "relative",
                paddingBottom: "10px",
              }}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)}
              {activeTab === tab && (
                <div
                  style={{
                    height: "3px",
                    backgroundColor: "#3761FF",
                    width: "100%",
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                  }}
                />
              )}
            </div>
          ))}
        </div>
       </div>
     <hr className="hrSeparatoR"/>  
    <div className="content-container">
    {activeTab === "Collaborateurs" && (
    <>
     <button
      type="button"
      className="btn btn-primary mb-3"
      style={{
        height: "40px",
        color: "#FFFFFF",
        backgroundColor: "#3761FF",
        borderColor: "#3761FF",
        borderRadius: "8px",
        fontFamily: "Poppins",
        fontSize: "15px",
        fontWeight: "500",
        padding: "0 15px",
        boxShadow: "0px 3px 8px rgba(0, 0, 0, 0.1)",
      }}
      onClick={openModal} 
      disabled = {(role == 'COLLABORATOR')}
      >
      Nouveau Collaborateur
    </button>
        <div
      style={{
        justifyContent: "start",
        alignItems: "start",
        display: "flex",
        flexDirection: "row",
      
      }}>
        <TableContainer
        columns={columns}
        data={colloborateurs || []}
        isGlobalSearch={true}
        isGlobalFilter={true}
        customPageSize={10}
        className="custom-header-css"
        divClass="table-responsive table-card mb-3"
        tableClass="align-middle table-nowrap"
        theadClass="table-light"
        SearchPlaceholder="Recherche..."
        isLoading={isLoading}
        isError={isError}
        error={error}
      />
        <NewCollaboratorModal
        show={showModal}
        onClose={closeModal}
        onCreated={refetch}
        merchantId={currentMerchantId} 
      />
      <CollaboratorDetailModal
        show={showDetailModal}
        onClose={() => setShowDetailModal(false)}
        collaborator={selectedMerchant}
      />
      <NewCollaboratorModal
        show={showModal}
        onClose={() => {
          setShowModal(false);
          setEditingCollab(null); // reset après fermeture
        }}
        onCreated={refetch}
        merchantId={currentMerchantId}
        editingCollab={editingCollab}
      />
      <DeleteCollaboratorModal
      show={showDelete}
      onClose={() => setShowDelete(false)}
      collaborator={selectedCollab}
      onDeleted={refetch}
    />
      </div>
     </>
    )}
    {activeTab === "Rôles" && (
        <> 
       <div
      style={{
        justifyContent: "start",
        alignItems: "start",
        display: "flex",
        flexDirection: "row",
      
      }}
    >
      <div
       style={{ 
         backgroundColor: "#F5F5F5", // orange pâle par défaut
        color: "#000",
        padding: "5px 5px",
        display: "flex",
      justifyContent: "center",
    
      borderRadius: "100px",                                                                                  
}}         
      >
  {tabs.map((tab1) => (
  <div
    key={tab1}
    onClick={() => handleTabChange(tab1)}
    className={` ${activeTab1 === tab1 ? "active" : ""}`}
    style={{
      backgroundColor: activeTab1 === tab1 ? "#396AFC" : "#F5F5F5",
      color: activeTab1 === tab1 ? "#FFFFFF" : "#141414",
      padding: "5px 20px",
      fontFamily: "Poppins",
      display: "flex",
      justifyContent: "center",
      textAlign: "center",
      fontWeight: 400,
      fontSize: "14px",
      fontStyle: "Medium",
      borderRadius: "100px",
      cursor: "pointer",
    }}
  >
    {tab1}
  </div>
))}

      </div>
      </div>
       {activeTab1 === "Administrateur" && (
        <> 
         <StaticRoles/>
         </>
        )}
         {activeTab1 === "Collaborateurs" && (
        <> 
         <Collaborateur/>
         </>
        )}
          </>
          )}
          
      </div>
  <Modal
  open={isModalOpen}
  onCancel={() => setIsModalOpen(false)}
  footer={null}
  width={150}
  style={{
    background: "#FFFFFF",
    position: "absolute",
    top: modalPosition.top,
    left: modalPosition.left,
    borderRadius: 10,
    border: "1px solid #DFDFDF",
    padding: 0,
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  }}
  bodyStyle={{ padding: "8px 1px" }}
  mask={false}
  closable={false}
>
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "12px",
    }}
  >
    <a
  onClick={() => {
    setIsModalOpen(false);
    setShowDetailModal(true); 
  }}
  style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
>
  <img src={eye} alt="Voir détails" style={{ width: 16, height: 16 }} />
  <span className="actions">Détails</span>
</a>

  <a
    onClick={() => {
      handleEdit(selectedMerchant); 
      setIsModalOpen(false); 
    }}
    style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
  >
    <img src={edit} alt="Modifier" style={{ width: 16, height: 16 }} />
    <span className="actions">Modifier</span>
  </a>

    <a
      onClick={() => {
       setIsModalOpen(false);
       setSelectedCollab(selectedMerchant);
      setShowDelete(true);

      }}
      style={{ display: "flex", alignItems: "start", gap: "8px", cursor: "pointer" }}
    >
      <img src={archive} alt="Voir détails" style={{ width: 16, height: 16}} />
      <span className="actions">Supprimer</span>
    </a>
  </div>
</Modal>

     </Row>
  );
};

export default Roles;
